import styled from 'styled-components'

export const CheckboxBase = styled.div`
  display: flex;
  justify-content: center;
  background-color: transparent;
`

export const CheckboxChecked = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const CheckboxContainer = styled.div``
